(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rail-controls"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rail-controls')) {
    customElements.define('rail-controls', class extends HTMLElement {
      connectedCallback() {
        this.rail = document.getElementById(this.getAttribute('target'));
        if (!this.rail) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const previous = this.querySelector('[data-rail-prev]');
        const next = this.querySelector('[data-rail-next]');
        this.update = () => {
          const maximum = this.rail.scrollWidth - this.rail.clientWidth;
          this.hidden = maximum < 3;
          this.rail.tabIndex = maximum < 3 ? -1 : 0;
          previous.disabled = this.rail.scrollLeft <= 2;
          next.disabled = this.rail.scrollLeft >= maximum - 2;
        };
        const move = direction => this.rail.scrollBy({ left: direction * this.rail.clientWidth * .8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        previous.addEventListener('click', () => move(-1), options);
        next.addEventListener('click', () => move(1), options);
        this.rail.addEventListener('keydown', event => {
          if (event.target !== this.rail || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }, options);
        this.rail.addEventListener('scroll', this.update, { ...options, passive: true });
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.rail);
        this.update();
      }
      disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
